<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ชนิดหัวชาร์จ EV</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">จัดการ master AC / DC สำหรับเรทราคาและประตู EV</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="px-5 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[18px]">add</span> เพิ่มชนิด
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">ev_station</span>รายการชนิดหัวชาร์จ
      </h3>
      <div class="relative w-full lg:max-w-md">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
          placeholder="ค้นหารหัส, ชื่อ..."
          class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">รหัส</th>
            <th class="p-4">ชื่อ</th>
            <th class="p-4">Name EN</th>
            <th class="p-4 text-center">ลำดับ</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4 text-center w-[120px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
            <td class="p-4">
              <span class="px-2.5 py-1 rounded-lg text-xs font-bold uppercase"
                [ngClass]="{
                  'bg-sky-50 dark:bg-sky-900/20 text-sky-600 dark:text-sky-400': item.code === 'ac',
                  'bg-violet-50 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400': item.code === 'dc',
                  'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400': item.code === 'ac_dc'
                }">
                {{ item.code || '—' }}
              </span>
              <div class="text-[11px] font-mono text-slate-400 mt-1">#{{ item.id }}</div>
            </td>
            <td class="p-4">
              <div class="font-bold text-slate-700 dark:text-slate-200">{{ item.name || '—' }}</div>
              <div class="text-[11px] text-slate-400" *ngIf="item.description">{{ item.description }}</div>
            </td>
            <td class="p-4 text-xs">{{ item.nameEn || '—' }}</td>
            <td class="p-4 text-center font-mono text-sm">{{ item.sortOrder != null ? item.sortOrder : '—' }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full border shadow-sm"
                [ngClass]="item.active
                  ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
                  : 'bg-slate-50 dark:bg-slate-900/40 text-slate-500 border-slate-200 dark:border-slate-600'">
                {{ item.active ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="p-4 text-center">
              <div class="inline-flex items-center gap-1">
                <button *ngIf="canUpdate" type="button" (click)="openEdit(item)" title="แก้ไข"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer">
                  <span class="material-icons text-base">edit</span>
                </button>
                <button *ngIf="canDelete && item.active" type="button" (click)="openDeactivateConfirm(item)" title="ปิดใช้งาน"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-rose-400 hover:text-rose-500 transition-all cursor-pointer">
                  <span class="material-icons text-base">block</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && items().length === 0">
            <td colspan="6" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">ev_station</span>
              <p class="font-bold">ยังไม่มีชนิดหัวชาร์จ</p>
              <p class="text-xs mt-1">กด “เพิ่มชนิด” เพื่อสร้าง AC / DC</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold cursor-pointer"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-ev-connector-type *ngIf="isModalOpen()"
  [itemId]="selectedId()"
  (close)="closeModal()"
  (saveSuccess)="onSaveSuccess()">
</app-modal-ev-connector-type>

<app-pss-confirm-modal *ngIf="isConfirmDeactivateOpen()"
  title="ยืนยันปิดใช้งานชนิดหัวชาร์จ?"
  message="จะตั้งสถานะเป็น Inactive สำหรับ"
  [highlight]="deactivateHighlight"
  messageSuffix="รายการนี้จะไม่โชว์ใน dropdown เรทราคา"
  confirmLabel="ปิดใช้งาน"
  cancelLabel="ยกเลิก"
  icon="block"
  variant="danger"
  [showIrreversibleNote]="false"
  (confirm)="confirmDeactivate()"
  (cancel)="closeDeactivateConfirm()">
</app-pss-confirm-modal>
